"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UtilsController", {
    enumerable: true,
    get: function() {
        return UtilsController;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _util = require("util");
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _utilsservice = require("~/services/utils.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
const _telemetryservice = require("~/services/telemetry.service");
const _config = require("~/interface/config");
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _catchError = require("~/helpers/catchError");
const _utils = require("~/utils");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let UtilsController = class UtilsController {
    async getVersion() {
        if (process.env.NC_CLOUD !== 'true') {
            return this.utilsService.versionInfo();
        }
        if (!this.version) {
            try {
                this.version = await (0, _util.promisify)(_fs.default.readFile)('./public/nc.txt', 'utf-8');
            } catch (unused) {
                this.version = 'Not available';
            }
        }
        return this.version;
    }
    async testConnection(body, req) {
        var _config_connection;
        body.pool = {
            min: 0,
            max: 1
        };
        let config = _extends({}, body);
        if (body.fk_integration_id) {
            var _config_connection1;
            const integration = await _models.Integration.get({
                workspace_id: _globals.RootScopes.BYPASS
            }, body.fk_integration_id);
            if (!integration || integration.type !== _nocodbsdk.IntegrationsType.Database) {
                _catchError.NcError.integrationNotFound(body.fk_integration_id);
            }
            if (integration.is_private && integration.created_by !== req.user.id) {
                _catchError.NcError.forbidden('You do not have access to this integration');
            }
            if (!req.user.roles[_nocodbsdk.OrgUserRoles.CREATOR]) {
                // check if user have owner/creator role in any of the base in the workspace
                const baseWithPermission = await _Noco.default.ncMeta.knex(_globals.MetaTable.PROJECT_USERS).innerJoin(_globals.MetaTable.PROJECT, `${_globals.MetaTable.PROJECT}.id`, `${_globals.MetaTable.PROJECT_USERS}.base_id`).where(`${_globals.MetaTable.PROJECT_USERS}.fk_user_id`, req.user.id).where((qb)=>{
                    qb.where(`${_globals.MetaTable.PROJECT_USERS}.roles`, _nocodbsdk.ProjectRoles.OWNER).orWhere(`${_globals.MetaTable.PROJECT_USERS}.roles`, _nocodbsdk.ProjectRoles.CREATOR);
                }).first();
                if (!baseWithPermission) _catchError.NcError.forbidden('You do not have access to this integration');
            }
            config = await integration.getConfig();
            (0, _utils.deepMerge)(config, body);
            if (config == null ? void 0 : (_config_connection1 = config.connection) == null ? void 0 : _config_connection1.database) {
                config.connection.database = (0, _nocodbsdk.getTestDatabaseName)(config);
            }
        }
        if ((_config_connection = config.connection) == null ? void 0 : _config_connection.ssl) {
            config.connection.ssl = (0, _nocodbsdk.validateAndExtractSSLProp)(config.connection, config.sslUse, config.client);
        }
        return await this.utilsService.testConnection({
            body: config
        });
    }
    async appInfo(req) {
        return await this.utilsService.appInfo({
            req: {
                ncSiteUrl: req.ncSiteUrl
            }
        });
    }
    async appHealth() {
        return await this.utilsService.appHealth();
    }
    async axiosRequestMake(body) {
        return await this.utilsService.axiosRequestMake({
            body
        });
    }
    async urlToDbConfig(body) {
        return await this.utilsService.urlToDbConfig({
            body
        });
    }
    async aggregatedMetaInfo() {
        // todo: refactor
        return await this.utilsService.aggregatedMetaInfo();
    }
    async feed(req) {
        return await this.utilsService.feed(req);
    }
    async cloudFeatures(req) {
        return await this.utilsService.cloudFeatures(req);
    }
    async reportErrors(req, body) {
        if (`${process.env.NC_DISABLE_ERR_REPORTS}` === 'true' || _utils.isEE || process.env.NC_SENTRY_DSN) {
            return {};
        }
        return await this.utilsService.reportErrors({
            req,
            body
        });
    }
    constructor(utilsService, telemetryService){
        this.utilsService = utilsService;
        this.telemetryService = telemetryService;
    }
};
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)('/api/v1/version'),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "getVersion", null);
_ts_decorate([
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Post)([
        '/api/v1/db/meta/connection/test',
        '/api/v2/meta/connection/test'
    ]),
    (0, _extractidsmiddleware.Acl)('testConnection', {
        scope: 'org'
    }),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "testConnection", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)([
        '/api/v1/db/meta/nocodb/info',
        '/api/v2/meta/nocodb/info',
        '/api/v1/meta/nocodb/info'
    ]),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "appInfo", null);
_ts_decorate([
    (0, _common.Get)('/api/v1/health'),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "appHealth", null);
_ts_decorate([
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Post)([
        '/api/v1/db/meta/axiosRequestMake',
        '/api/v2/meta/axiosRequestMake'
    ]),
    (0, _extractidsmiddleware.Acl)('fetchViaUrl'),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "axiosRequestMake", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Post)('/api/v1/url_to_config'),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "urlToDbConfig", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)('/api/v1/aggregated-meta-info'),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "aggregatedMetaInfo", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)('/api/v2/feed'),
    _ts_param(0, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "feed", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)('/api/v2/cloud-features'),
    _ts_param(0, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "cloudFeatures", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Post)('/api/v1/error-reporting'),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.ErrorReportReqType === "undefined" ? Object : _nocodbsdk.ErrorReportReqType
    ]),
    _ts_metadata("design:returntype", Promise)
], UtilsController.prototype, "reportErrors", null);
UtilsController = _ts_decorate([
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _utilsservice.UtilsService === "undefined" ? Object : _utilsservice.UtilsService,
        typeof _telemetryservice.TelemetryService === "undefined" ? Object : _telemetryservice.TelemetryService
    ])
], UtilsController);
